module.exports = __webpack_public_path__ + "img/CM-KT-25-Chevy-Lifestyle.a7902373.jpg";